import config from 'src/config.js'

function dynamicColors() {
    let r = Math.floor(Math.random() * 255);
    let g = Math.floor(Math.random() * 255);
    let b = Math.floor(Math.random() * 255);
    return "rgba(" + r + "," + g + "," + b + ", 0.5)";
}

export default {
    getColorByIndex: index => config.colors[index] || dynamicColors(),
    getColorByName: color => config.colorsByName[color] || dynamicColors(),
    num2money: (n, c, d, t) => {
        if ( typeof(n) === 'string' ) { n = n.replace(',', '.'); }
            c = isNaN(c = Math.abs(c)) ? 2 : c;
            d = d == undefined ? "," : d;
            t = t == undefined ? "." : t;
        let s = n < 0 ? "-" : "";
        let i = parseInt(n = Math.abs(+n || 0).toFixed(c), 10) + "";
        let j = (j = i.length) > 3 ? j % 3 : 0
        return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    }
}